import React from 'react';

export default function StudioMetricsMenuTabs({active, onChange, children}) {
  return <>
    <nav className="--TSD-metrics-subtabs" aria-label="Metrics menu sections">
      {[
        ['statistics', 'Match statistics'],
        ['review', 'Improvement Points & Focus Points'],
      ].map(([key, label]) => <button
        key={key}
        className={`--TSD-category-tab ${active === key ? '--TSD-is-active' : ''}`}
        type="button"
        aria-pressed={active === key}
        onClick={() => onChange(key)}
      >{label}</button>)}
    </nav>
    <div className="--TSD-review-menu" hidden={active !== 'review'}>
      {children}
    </div>
  </>;
}
